import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from './Icon';

interface PagenationProps {
  listAllLength: number | undefined;
  listLimit: number | undefined;
  onCurrentPageChange: (value: number) => void;
}

const Pagenation = ({
  listAllLength,
  listLimit,
  onCurrentPageChange,
}: PagenationProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(Number(listAllLength) / Number(listLimit));

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    onCurrentPageChange(pageNumber);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [listLimit, listAllLength]);

  const startPage = Math.floor((currentPage - 1) / 10) * 10 + 1; // 현재 페이지를 기준으로 시작 페이지
  const endPage = Math.min(startPage + 9, totalPages); // 10 페이지까지 표시하지만 totalPages를 넘지 않도록

  return (
    <>
      <Wrap>
        <ArrowBox>
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            <Icon name="ArrowPrevDoubleIcon" size="100%" color="#949494" />
          </button>
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <Icon name="ArrowPrevIcon" size="100%" color="#949494" />
          </button>
        </ArrowBox>
        <NumBox>
          {[...Array(endPage - startPage + 1)].map((_, index) => {
            const pageNumber = startPage + index;
            return (
              <li
                key={pageNumber}
                className={currentPage === pageNumber ? 'active' : ''}
                onClick={() => handlePageChange(pageNumber)}
              >
                {pageNumber}
              </li>
            );
          })}
        </NumBox>
        <ArrowBox>
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <Icon name="ArrowNextIcon" size="100%" color="#949494" />
          </button>
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            <Icon name="ArrowNextDoubleIcon" size="100%" color="#949494" />
          </button>
        </ArrowBox>
      </Wrap>
    </>
  );
};

export default Pagenation;

export const Wrap = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const ArrowBox = styled.div`
  display: flex;
  gap: 4px;
  button {
    width: 16px;
    &:disabled {
      opacity: 0;
      cursor: inherit;
    }
  }
`;

export const NumBox = styled.ul`
  display: flex;
  gap: 4px;
  > li {
    width: 24px;
    height: 24px;
    border-radius: 2px;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #949494;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &.active {
      background: ${(props) => props.theme.mainColor1};
      color: #fff;
    }
  }
`;
